var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c("span", {
      staticClass: "icon",
      class: _vm.icon,
      staticStyle: { "font-size": "19px" },
      attrs: { "aria-hidden": "true" },
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "font-size-16 fw-bold text-mw",
      staticStyle: { "padding-left": "7px" },
      domProps: { innerHTML: _vm._s(_vm.label) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }